import React, { useState } from "react";
import { Request } from "../../api/auth/Password.api";
import ResetPasswordView from "../../views/auth/ResetPasswordView";
import Error from "../../components/Error";
import Loading from "../../components/Loading";
import Success from "../../components/Success";
import { useTranslation } from "react-i18next";

const initialValues = {
  email: "",
};

const ResetPasswordContainer = ({ message }) => {
  const { t } = useTranslation();

  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(false);
  const [success, setSuccess] = useState(null);

  const onSubmit = (values, actions) => {
    setSuccess(null);
    setError(null);
    setLoading(true);
    Request.resetPassword(values)
      .then((data) => onSuccess(data, actions))
      .catch((error) => onFailure(error, actions));
  };

  const onSuccess = ({ data }, actions) => {
    setSuccess(true);
    actions.setSubmitting(false);
    setLoading(false);
  };

  const onFailure = (error, actions) => {
    if (error.message === "error_generic_404") {
      setError({ message: t("reset.username_does_not_exist") });
    } else {
      setError(error);
    }
    setLoading(false);
    actions.setSubmitting(false);
  };

  return (
    <>
      {success ? (
        <Success message={message} onClose={() => setSuccess(null)} />
      ) : null}
      {error ? <Error message={error} onClose={() => setError(null)} /> : null}
      {loading ? <Loading /> : null}
      <ResetPasswordView onSubmit={onSubmit} initialValues={initialValues} />
    </>
  );
};

export default ResetPasswordContainer;
